<template>
  <div class="reschedule-data-table">
    <data-table :header="table.header">
      <div
        v-for="(reschedule, orderIndex) in rescheduleList"
        :key="orderIndex"
        class="data-table__body__row"
      >
        <data-cell :size="20">
          <h3>{{ reschedule.idOrder }}</h3>
        </data-cell>
        <data-cell :size="20">
          <p>{{ reschedule.codeExamBrand }}</p>
        </data-cell>
        <data-cell :size="60">
          <p>
            O exame, do paciente <span class="patient">{{ reschedule.patientName }}</span>, com resultado prometido para
            <strong class="date-old">{{ convertDataWithoutTimeZone(reschedule.originalDueDate) }}</strong>, foi remarcado para <strong class="date-new">{{ convertDataWithoutTimeZone(reschedule.dueDate) }}</strong><span v-if="reschedule.reason">, <strong class="reason">{{ reschedule.reason }}</strong></span>. Para mais detalhes, entre em contato com o <strong>Conexão Álvaro no 0800 643 8100</strong>.
          </p>

          <ul
            v-if="reschedule.rescheduledEvents && reschedule.rescheduledEvents.length > 1"
            class="reschedule-data-table__historical-list"
          >
            <li>Histórico de Remarcações:</li>
            <li
              v-for="(event, eventIndex) in reschedule.rescheduledEvents"
              :key="eventIndex"
            >
              Remarcado para <strong class="date-new">{{ convertDataWithoutTimeZone(event.dueDate) }}</strong>, no dia <strong>{{ convertDataWithoutTimeZone(event.rescheduledDate) }}</strong><span v-if="event.reason">, motivo: <strong class="reason">{{ event.reason }}</strong></span>
            </li>
          </ul>
        </data-cell>
      </div>
    </data-table>

    <infinite-loading
      slot="append"
      ref="infiniteLoading"
      :force-use-infinite-wrapper="true"
      @infinite="onInfinite()"
    >
      <span slot="no-more" />
      <span slot="no-results" />
      <span slot="spinner">
        <spinner />
      </span>
    </infinite-loading>

    <div
      v-if="rescheduleListStatusLoading === 'STATUS_END' && rescheduleList.length === 0"
      class="empty-search"
    >
      <svg-loader src="/static/images/icon-no-tubes-found.svg" />
      <p>Não encontramos nenhum resultado para sua busca.</p>
    </div>

    <div
      v-if="rescheduleListStatusLoading === 'STATUS_FAILED' && rescheduleList.length === 0"
      class="empty-search"
    >
      <svg-loader src="/static/images/icon-no-tubes-found.svg" />
      <p>Não foi possível buscar remarcações. Tente novamente.</p>
    </div>
  </div>
</template>

<script>
import DataTable from '../common/dataTable/DataTable'
import DataCell from '../common/dataTable/DataCell'
import DataShowOff from '../common/dataTable/DataShowOff'
import { mapGetters, mapActions } from 'vuex'
import Spinner from '../common/Spinner'
import InfiniteLoading from 'vue-infinite-loading'
import Moment from 'moment'

export default {
  name: 'RescheduleDataTable',
  components: {
    'data-table': DataTable,
    'data-cell': DataCell,
    'data-showoff': DataShowOff,
    spinner: Spinner,
    'infinite-loading': InfiniteLoading
  },
  filters: {
    date: function (value) {
      return Moment(value).format('DD/MM/yyyy')
    },
    hour: function (value) {
      return Moment(value).format('HH:mm')
    }
  },
  data() {
    return {
      table: {
        header: [
          {
            title: 'OS',
            size: 20
          },
          {
            title: 'Exame',
            size: 20
          },
          {
            title: 'data de entrega',
            size: 60
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['rescheduleList', 'rescheduleListStatusLoading'])
  },
  watch: {
    rescheduleListStatusLoading: function (newValue) {
      switch (newValue) {
        case 'STATUS_END':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_SUCCESS':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          this.setWaitingRescheduleLoadingStatus()
          break
        case 'STATUS_FAILED':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_INITIAL':
          if (this.$refs.infiniteLoading) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
          }
          break
        case 'STATUS_WAITING':
          break
        default:
          break
      }
    }
  },
  methods: {
    ...mapActions(['getRescheduleList', 'setWaitingRescheduleLoadingStatus']),
    onInfinite() {
      this.getRescheduleList()
    },
    examsLimited: function (exams) {
      return exams.length > 3 ? exams.slice(0, 3) : exams
    },
    convertDataWithoutTimeZone(date) {
      let dateTime = Moment.utc(date)

      const formattedDate = dateTime.format('DD/MM/YYYY')
      const formattedTime = dateTime.format('HH:mm')

      return formattedDate + ' às ' + formattedTime
    }
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.reschedule-data-table {
  &__historical-list {
    padding-left: 16px;
    margin-top: 12px;

    li {
      list-style-type: disc;

      &:first-child {
        list-style: none;
        margin-left: -16px;
        font-weight: bold;
        color: #363636;
      }
    }
  }

  .data-table__body__row {
    height: auto;

    &__cell {
      margin: 10px 0;
    }

    h3 {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 26px;
      color: #4a4a4a;
    }

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 26px;
      color: #4a4a4a;
    }

    .patient {
      font-weight: bold;
      color: $jaffa;
    }

    .date {
      &-new {
        color: green;
      }
      &-old {
        color: red;
      }
    }

    .reason {
      text-transform: lowercase;
    }
  }

  .empty-search {
    width: 25%;
    position: relative;
    margin: 6% auto auto;

    .md-icon {
      width: 50px;
      height: 50px;
      margin-bottom: 1em;
      margin-left: 40%;
    }

    p {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      text-align: center;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #7a7a7a;
    }
  }
}
</style>
